export default {
  app: {
    privacy: {
      policy: 'adatvédelmi irányelvek',
      expansive: 'Az Expansive használatával elfogadja az Expansive {action}-t',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Munkamenet lejárt',
    sessionExpiredDescription:
      'A munkamenet lejárt. Kérjük, jelentkezzen be újra az alkalmazás használatához.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Nyelv kiválasztása',
      chooseLanguageDescription:
        'Válassza ki az alkalmazás kívánt nyelvét. Ez megváltoztatja a felület és a tartalom nyelvét.',
    },
    userSelection: {
      cancel: 'Mégse',
      createNewUser: 'Nincs a listán a nevük',
      newUser: 'Új felhasználó',
      selectAnExistingUser: 'Válasszon meglévő felhasználót',
      selectUserHint: 'Válasszon meglévő felhasználót vagy hozzon létre újat a folytatáshoz.',
      startTypingToSearch: 'Kezdje el gépelni...',
    },
    verification: {
      codeVerification: {
        continue: 'Folytatás',
        header: 'Adja meg a helyszíni belépési kódot',
        invalidCode: 'Érvénytelen kód, próbálja újra.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Folytatás helymeghatározás nélkül',
        enterSiteAccessCode: 'Adja meg a helyszíni belépési kódot',
        locationNotEnabledOrAvailable: 'Miért látom ezt?',
        notAvailable: {
          description: 'A GPS helymeghatározás nem támogatott ezen az eszközön.',
          header: 'A helymeghatározás nem támogatott',
        },
        notEnabled: {
          description:
            'A helymeghatározási szolgáltatások nincsenek engedélyezve vagy az engedély nem lett megadva.',
          header: 'A helymeghatározás nincs engedélyezve',
        },
        notVerified: {
          description: 'A GPS azt jelzi, hogy nincs a helyszínen.',
          header: 'Helyszín nem ellenőrizött',
        },
        tryAgain: 'Próbálja újra',
        unavailable: {
          description: 'Nem sikerült ellenőrizni a GPS helyzetét.',
          header: 'Helyszín nem elérhető',
        },
        unknown: {
          description: 'Nem tudjuk meghatározni a helyzetét.',
          header: 'Ismeretlen helyszín',
        },
        verified: {
          description: 'A GPS azt jelzi, hogy a helyszínen van.',
          header: 'Helyszín ellenőrizve',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Nem található eszköz',
        emptyDescription: 'Ehhez a munkamegrendeléshez nem tartoznak eszközök.',
        warrantyParts: 'Alkatrész garancia lejár',
        serialNumber: 'Sorozatszám',
        none: '<nincs>',
      },
      updates: {
        emptyTitle: 'Nem található frissítés',
        emptyDescription: 'Ehhez a munkamegrendeléshez nincs frissítés.',
        unknownUser: 'Ismeretlen felhasználó',
        none: 'Nincs',
        addComment: {
          buttonLabel: 'Hozzászólás hozzáadása',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Veszélyek',
          no: 'Nem',
          yes: 'Igen',
        },
      },
    },
    attachmentsList: {
      attachments: 'Mellékletek',
      documents: 'Dokumentumok',
      siteDocuments: 'Helyszíni dokumentumok',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Veszélyek',
        induction: 'Bevezetés',
        safeToProceed: 'Biztonságos folytatni',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Határidő',
        activeSessions: 'Aktív munkamenetek',
        activeSessionsDescription:
          'Már be van jelentkezve a következő munkamegrendelésekbe. Ezekből ki kell jelentkeznie, mielőtt újba jelentkezne be.',
        resumeSession: 'Folytatás',
        startTime: 'Kezdés ideje',
        unexpectedErrorTitle: 'Váratlan hiba',
        unexpectedErrorMessage:
          'Váratlan hiba történt a munkamenetek létrehozása közben. Kérjük, próbálja újra később.',
        engineerNotFound: 'A mérnök nem található',
        engineerNotFoundDescription:
          'A bejelentkezni kívánt mérnök nem található a rendszerben. Kérjük, vegye fel a kapcsolatot az adminisztrátorral.',
      },
      verification: {
        code: {
          description:
            'A bejelentkezéshez kérje el a 4 jegyű kódot a helyszíni vezetőtől vagy a kijelölt kapcsolattartótól.',
        },
        geo: {
          continue: 'Folytatás',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Kérjük, szerezze be a hozzáférési kódot a telephely vezetőjétől vagy a kijelölt kapcsolatfelvételtől a látogatás befejezéséhez.',
            checkOut: 'Kijelentkezés',
            completeBeforeLeaving: 'Kérjük, töltse ki az alábbi űrlapot távozás előtt.',
            continue: 'Folytatás',
            noResolutionSelected: 'Kérjük, válasszon megoldást a folytatáshoz.',
            quoteRequired: {
              hint: 'Látogatás befejezve, árajánlat következik',
              label: 'Árajánlat szükséges',
            },
            returnVisitRequired: {
              hint: 'Vissza fogunk térni a befejezéshez',
              label: 'Visszalátogatás szükséges',
            },
            serviceCompleted: {
              hint: 'Nincs további teendő',
              label: 'Szolgáltatás befejezve',
            },
            uploadCheckout: 'Fájl, fénykép vagy videó feltöltése',
            visitNotes: 'Látogatási jegyzetek',
            workOrderResolution: 'Munkamegrendelés megoldása',
            enterNotes: 'Írja be a jegyzeteket ide...',
            errors: {
              timedOut: 'Időtúllépés, meghaladta a 30 másodpercet. Kérjük, próbálja újra.',
              closingSession: 'Hiba a munkamenet lezárásakor',
            },
          },
          success: {
            description:
              'Köszönjük, hogy ellátogatott {site}-ra. | {site}-on még 1 nyitott munkamegrendelés van. | {site}-on még {count} nyitott munkamegrendelés van.',
            endVisit: 'Látogatás befejezése',
            header: 'Sikeresen kijelentkezett',
            viewWorkOrders: 'Jelentkezzen be másik munkamegrendelésbe',
          },
          verification: {
            code: {
              description:
                'A kijelentkezéshez kérje el a 4 jegyű kódot a helyszíni vezetőtől vagy a kijelölt kapcsolattartótól.',
              continue: 'Folytatás',
            },
            geo: {
              checkOut: 'Kijelentkezés',
              continue: 'Folytatás',
            },
          },
        },
        detail: {
          assets: 'Eszközök',
          call: 'Hívás',
          checkOut: 'Kijelentkezés',
          closed: 'Lezárva',
          details: 'Részletek',
          dueBy: 'Határidő',
          manageEngineers: 'Mérnökök kezelése',
          notAvailable: 'Nem elérhető',
          pointOfContact: 'Kapcsolattartó',
          siteAccessTimes: 'Helyszíni hozzáférési idők',
          siteAccessInstructions: 'Hozzáférési utasítások',
          siteAddress: 'Helyszín címe',
          siteNotes: 'Helyszíni jegyzetek',
          siteTelephone: 'Helyszíni telefon',
          siteLocation: 'Helyszín elhelyezkedése',
          updates: 'Frissítések',
          more: 'Több',
          mismatchErrorTitle: 'Munkamegrendelés hiba',
          mismatchErrorMessage:
            'A megnyitni kívánt munkamegrendelés nem egyezik a jelenleg bejelentkezettel. Kérjük, ellenőrizze a munkamegrendelést és próbálja újra.',
          siteDocuments: 'Helyszíni dokumentumok',
          validFrom: 'Érvényes ettől',
          validUntil: 'Érvényes eddig',
          documentName: 'Dokumentum neve',
          documentType: 'Dokumentum típusa',
          attachments: 'Munkamegrendelés fájljai',
          download: 'Letöltés',
          workDetails: 'Munka részletei',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Segédmérnök hozzáadása',
            assistantEngineers: 'Segédmérnökök',
            description: 'Biztonsági okokból kérjük, adja meg minden helyszíni mérnök nevét.',
            editMainEngineer: 'Főmérnök szerkesztése',
            errors: {
              creatingEngineer: 'Hiba a mérnök létrehozásakor',
              creatingSession: 'Hiba a munkamenet létrehozásakor',
            },
            header: 'Mérnökök a helyszínen',
            mainEngineer: 'Főmérnök',
            newAssistantEngineer: 'Adja meg a teljes nevét',
            next: 'Következő',
            removeEngineer: 'Mérnök eltávolítása',
            selectExistingAssistantEngineer: 'Kezdje el beírni a nevét',
          },
          index: {
            description: 'Biztonsági okokból kérjük, adja meg minden helyszíni mérnök nevét.',
            errorCreatingEngineer: 'Hiba a mérnök létrehozásakor, próbálja újra.',
            header: 'Mérnökök a helyszínen',
            hintMainEngineer: 'Adja meg a főmérnök teljes nevét',
            newMainEngineer: 'Új főmérnök',
            next: 'Következő',
            selectExistingMainEngineer: 'Válasszon meglévő főmérnököt',
            yes: 'Igen',
            no: 'Nem',
            mainEngineerLabel: 'Ön a főmérnök?',
          },
        },
        index: {
          callUsOn: 'Hívjon minket ezen: {phoneNumber}',
          description: 'Nem találja, amit keres?',
          dueBy: 'Határidő',
          header: 'Munkamegrendelés kiválasztása',
          notAvailable: 'Nem elérhető',
          searchWorkOrders: 'Munkamegrendelések keresése...',
        },
        manageEngineers: {
          manageEngineers: 'Mérnökök kezelése',
          notWorking: 'Inaktív dolgozók',
          pause: 'Szünet',
          resume: 'Folytatás',
          workingNow: 'Aktív dolgozók',
          startTime: 'Kezdés ideje',
          endTime: 'Befejezés ideje',
          duration: 'Időtartam',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Visszajelzés',
            feedbackDescription:
              'Kérjük, adjon visszajelzést a munkamegrendelésről, hogy javíthassuk szolgáltatásainkat.',
            feedbackLabel: 'Visszajelzés',
            filesLabel: 'Mellékletek',
            submissionLabel: 'Visszajelzés beküldése',
          },
          hazards: {
            back: 'Vissza',
            hazards: 'Veszélyek',
            next: 'Következő',
            no: 'Nem',
            noTasksForHazard: 'Ehhez a veszélyhez nincs elvégzendő feladat.',
            yes: 'Igen',
          },
          induction: {
            continue: 'Folytatás',
            induction: 'Bevezetés',
          },
          index: {
            checkIn: 'Bejelentkezés',
            description: 'Kérjük, töltse ki a kiválasztott munkához tartozó kockázatértékelést.',
            fail: 'A munkakezdési ellenőrzések feldolgozása sikertelen.',
            haltMessage:
              'Lehetséges kockázatok észlelve. Kérjük, állítsa le a munkát, tekintse át a biztonsági előírásokat, és vegye fel a kapcsolatot a felettesével.',
            header: 'Munkakezdési ellenőrzések',
            endVisit: 'Látogatás befejezése',
            leaveFeedback: 'Visszajelzés adása',
          },
          safeToProceed: {
            continue: 'Folytatás',
            safeToProceed: 'Biztonságos folytatni',
          },
        },
      },
    },
    index: {
      title: 'Üdvözöljük',
      description: 'A kezdéshez olvassa be a helyszínen található QR-kódot.',
    },
    login: {
      errorTitle: 'Váratlan hiba',
      errorMessage: 'Váratlan hiba történt. Kérjük, próbálja újra beolvasni a QR-kódot.',
    },
    unauthenticated: {
      welcome: {
        title: 'Üdvözöljük a(z) {site} oldalon',
        description:
          'Mielőtt megjelenítenénk a munkamegrendeléseket, ellenőriznünk kell az adatait. A folytatáshoz kattintson az alábbi gombra.',
        next: 'Folytatás',
      },
      index: {
        errorTitle: 'Váratlan hiba',
        errorMessage: 'Váratlan hiba történt. Kérjük, próbálja újra beolvasni a QR-kódot.',
      },
      contractor: {
        title: 'Kinek dolgozik?',
        contractor: 'Vállalkozó',
        contractorLabel: 'Kezdje el beírni a cég nevét',
        contractorHint: 'Legalább 3 karaktert kell megadnia az eredmények megjelenítéséhez',
        defaultSelectPlaceholder: '--Kérem, válasszon--',
        next: 'Következő',
      },
      user: {
        title: 'Ki ön?',
        cancel: 'Mégse',
        createNewUserLabel: 'A nevem nincs a listán',
        existingUserLabel: 'Kezdje el beírni a nevét',
        existingUserHint: 'Legalább 3 karaktert kell megadnia az eredmények megjelenítéséhez',
        newUserLabel: 'Adja meg a teljes nevét',
        next: 'Következő',
        user: 'Felhasználó',
      },
      verification: {
        methods: {
          add: {
            add: 'Ellenőrzési mód hozzáadása',
            defaultSelectPlaceholder: '--Kérem, válasszon--',
            emailLabel: 'E-mail',
            existingMethodWarning:
              'Már van függőben lévő kérelme ehhez az ellenőrzési módhoz, amely adminisztrátori jóváhagyásra vár. Új hozzáadása felülírja azt.',
            method: 'Módszer',
            methodLabel: 'Módszer',
            mobileCountryHint: 'Kérjük, válassza ki az országkódot',
            mobileCountryLabel: 'Mobil országkód',
            mobileHint: 'Kérjük, adja meg a mobilszámát',
            mobileLabel: 'Mobil',
            title: 'Ellenőrzési mód hozzáadása',
          },
          confirm: {
            confirm: 'Megerősítés',
            description: 'Kérjük, erősítse meg az ellenőrzési módot a folytatáshoz.',
            label: 'Adja meg a kódot',
            resend: 'Újraküldés',
            resendPrompt: 'Nem kapott kódot?',
            title: 'Ellenőrzési mód megerősítése',
          },
          confirmed: {
            description:
              'Értesítést kap, amint ezt az ellenőrzési módot adminisztrátora jóváhagyja, és ezután használhatja személyazonossága igazolására.',
            forceApproval: 'Amíg nincs jóváhagyva, nem fér hozzá a munkamegrendelésekhez.',
            nonForceApproval:
              'Időközben korlátozott hozzáféréssel továbbra is elérheti a munkamegrendeléseket.',
            nonForceApprovalButtonLabel: 'Folytatás korlátozott hozzáféréssel',
            title: 'Jóváhagyásra vár',
          },
          addNew: 'Új ellenőrzési mód hozzáadása',
          description:
            'Személyazonosságának ellenőrzésére van szükség, hogy teljes hozzáférést kapjon a munkamegrendeléshez.',
          email: 'E-mail',
          hint: 'A kiválasztott ellenőrzési módra küldünk egy linket, amely teljes hozzáférést biztosít a munkamegrendeléshez. Ha módosítani szeretné a meglévő ellenőrzési módokat, kérjük, vegye fel a kapcsolatot az adminisztrátorral.',
          label: 'Válasszon ellenőrzési módot',
          next: 'Következő',
          pendingHint: 'Adminisztrátori jóváhagyásra vár',
          sms: 'SMS',
          title: 'Ellenőrzés',
        },
        optional: {
          hint: 'Felhasználói adatainak ellenőrzése teljes hozzáférést biztosít a munkamegrendeléshez',
          label: 'Szeretné ellenőrizni a felhasználói adatait?',
          next: 'Következő',
          no: 'Nem',
          noHint:
            'Nem szeretném ellenőrizni a felhasználói adataimat, és korlátozott hozzáféréssel folytatom a munkamegrendelést',
          title: 'Ellenőrzés',
          yes: 'Igen',
          yesHint:
            'Szeretném ellenőrizni a felhasználói adataimat, és teljes hozzáférést kapni a munkamegrendeléshez',
        },
        sent: {
          description:
            'Bejelentkezési linket küldtünk a következőre: {identifier}. Kérjük, kattintson a linkre a bejelentkezés befejezéséhez.',
          title: 'Bejelentkezési link elküldve',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Tegnap',
      today: 'Ma',
      days: {
        monday: 'Hétfő',
        tuesday: 'Kedd',
        wednesday: 'Szerda',
        thursday: 'Csütörtök',
        friday: 'Péntek',
        saturday: 'Szombat',
        sunday: 'Vasárnap',
      },
      months: {
        january: 'Január',
        february: 'Február',
        march: 'Március',
        april: 'Április',
        may: 'Május',
        june: 'Június',
        july: 'Július',
        august: 'Augusztus',
        september: 'Szeptember',
        october: 'Október',
        november: 'November',
        december: 'December',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Valami hiba történt',
      message: 'Kérjük, próbálja újra beolvasni a QR-kódot.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Ismeretlen felhasználó',
      },
      none: 'Nincs',
      types: {
        stateTransition: 'Állapot megváltozott',
        contractorAssigned: 'Vállalkozó hozzárendelve',
        engineerAssigned: 'Mérnök hozzárendelve',
        serviceAssigned: 'Szolgáltatás hozzárendelve',
        priorityChanged: 'Prioritás megváltozott',
        actionableDateChanged: 'Végrehajtható dátum megváltozott',
        dueDateChanged: 'Határidő megváltozott',
        etaDateChanged: 'Várható érkezési idő megváltozott',
        spendLimitApproved: 'Költési limit jóváhagyva',
        spendLimitCancelled: 'Költési limit kérelme visszavonva',
        spendLimitRejected: 'Költési limit elutasítva',
        spendLimitRequested: 'Költési limit igényelve',
        jobSheetUploaded: 'Munkalap feltöltve',
        slaAlertSent: 'SLA figyelmeztetés küldve',
        issuedWorkPermit: 'Munkavégzési engedély kiadva',
        requestForServiceSent: 'Szolgáltatási kérelem elküldve',
        comment: 'Hozzászólás hozzáadva',
        unknown: 'Ismeretlen esemény',
      },
      labels: {
        actionableDate: 'Végrehajtható dátum',
        comment: 'Hozzászólás',
        file: 'Fájl',
        contractor: 'Vállalkozó',
        dueDate: 'Határidő',
        etaDate: 'Várható érkezési idő',
        engineer: 'Mérnök',
        priority: 'Prioritás',
        requestForService: 'Szolgáltatási kérelem',
        service: 'Szolgáltatás',
        spendLimit: 'Költési limit',
        status: 'Állapot',
        workPermit: 'Munkavégzési engedély',
      },
    },
  },
}
